import React from "react";
import DeployCache, {
  isShowCache,
} from "src/components/deployCache/DeployCache";
import { useState } from "react";
import { CACHE_ROGO_DEV_TYPE } from "src/constants/actionCache";
import FLFRogoDevTypePopup from "../Popup/FLFRogoDevTypePopup";
import ShowCacheFLFRogoDevType from "../ShowCache/ShowCacheFLFRogoDevType";

const FLFRogoDevTypeControlPanel = ({
  children,
  currentActionCache,
  recordForEdit,
  openPopup,
  setOpenPopup,
  handleOpenPopup,
  addOrEdit,
  errorsForm,
}) => {
  const [disableButton, setDisableButton] = useState(false);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div>{children}</div>
      <div>
        <DeployCache
          title="Cache RogoDevType"
          isShowButton={isShowCache(currentActionCache, CACHE_ROGO_DEV_TYPE)}
        >
          <ShowCacheFLFRogoDevType
            disableButton={disableButton}
            setDisableButton={setDisableButton}
          />
        </DeployCache>

        <FLFRogoDevTypePopup
          recordForEdit={recordForEdit}
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
          handleOpenPopup={handleOpenPopup}
          addOrEdit={addOrEdit}
          errorsForm={errorsForm}
        />
      </div>
    </div>
  );
};

export default FLFRogoDevTypeControlPanel;
